export const helpers = {
  FormatDateToYYYYMMDD: (date) => {
    const dateObject = new Date(date)
    const year = dateObject.getFullYear()
    const month = dateObject.getMonth() + 1
    const day = dateObject.getDate()
    // Return the date in the format yyyy-MM-dd
    return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
  },
  
  FormatNumber: (number, decimals) => {
    const formatOptions = {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
      useGrouping: true,
    };
    return number.toLocaleString('en-US', formatOptions);
  }
}